import React, { useState, useEffect } from "react";
import { getNext7Days } from "../../../../utils/utils";

export const TutorAvailabilitySection = ({ availability }) => {
    const [next7Days, setNext7Days] = useState([]);

    useEffect(() => {
        setNext7Days(getNext7Days());
    }, []);

    // Find availability for a specific day
    const findAvailability = (day) => {
        const availDay = availability?.find((a) => a.day === day);
        return availDay ? availDay.slots : [];
    };

    return (
        <div className="card shadow-sm mb-4">
            <div className="card-header bg-white py-3">
                <h4 className="card-title mb-0">
                    <i className="fas fa-calendar-alt text-primary me-2"></i>
                    Weekly Availability
                </h4>
            </div>
            <div
                className="card-body p-3"
                style={{ minHeight: "auto" }}
            >
                {next7Days.map((day, index) => (
                    <div
                        key={index}
                        className="mb-3 pb-3 border-bottom"
                    >
                        <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                            <h5 className="mb-2 mb-md-0">
                                {day.day} ({day.date})
                            </h5>
                            {findAvailability(day.day).length > 0 ? (
                                <span className="badge bg-success">
                                    Available
                                </span>
                            ) : (
                                <span className="badge bg-warning">
                                    Not Available
                                </span>
                            )}
                        </div>
                        {findAvailability(day.day).length > 0 ? (
                            <div className="d-flex flex-wrap">
                                {findAvailability(day.day).map(
                                    (slot, slotIndex) => (
                                        <span
                                            key={slotIndex}
                                            className="badge bg-light text-dark me-2 mb-2 p-2"
                                        >
                                            <i className="far fa-clock me-1"></i>{" "}
                                            {slot}
                                        </span>
                                    )
                                )}
                            </div>
                        ) : (
                            <span className="text-muted">
                                <i className="fas fa-ban me-2"></i>
                                Not available
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};